/** Back-office tools for each market, from CK's per-market feature lists. Generated; edit pages here as features gain their own screens. */
export interface MarketKitFeature { name: string; note: string; page: string | null }
export const MARKET_KITS: Record<string, { name: string; features: MarketKitFeature[] }[]> = {
 "prop": [
  {
   "name": "CK Funded back office",
   "features": [
    {
     "name": "Trader Profile View",
     "note": "View personal details, trading history, active metrics, and compliance logs in one screen.",
     "page": "traders"
    },
    {
     "name": "Manual Account Phase Override",
     "note": "Force-move a trader from an evaluation phase to a funded or scaled tier.",
     "page": "accounts"
    },
    {
     "name": "Account Balance & Equity Adjustment",
     "note": "Issue manual financial credits, debits, or deposit adjustments directly to trading accounts.",
     "page": "accounts"
    },
    {
     "name": "Rule Breach Reset Button",
     "note": "Instantly reinstate a failed account or clear a breach flag for a trader.",
     "page": "accounts"
    },
    {
     "name": "Credentials Reset Tool",
     "note": "Regenerate and resend platform trading passwords or security tokens.",
     "page": "accounts"
    },
    {
     "name": "Bulk Account Assignment",
     "note": "Apply specific rulesets, risk metrics, or custom conditions to multiple accounts at once.",
     "page": null
    },
    {
     "name": "IP and Device Tracking Lookup",
     "note": "Cross-reference login IPs and device fingerprints to detect account management or sharing.",
     "page": "duplicates"
    },
    {
     "name": "Internal Memo Logging",
     "note": "Add private operational notes and flags to a trader's profile for internal staff reference.",
     "page": null
    },
    {
     "name": "Real-Time Live Trade Monitor",
     "note": "Stream all open positions, margins, and floating PnL running across the platform.",
     "page": null
    },
    {
     "name": "Breach Rule Configurator",
     "note": "Adjust parameters for daily drawdown, max drawdown, profit targets, and minimum trading days.",
     "page": "plans"
    },
    {
     "name": "Emergency Global Kill-Switch",
     "note": "Instantly close all open positions or freeze trading across the entire firm.",
     "page": null
    },
    {
     "name": "A-Book / B-Book Routing Toggle",
     "note": "Route specific traders between demo execution and live STP liquidity bridges.",
     "page": null
    },
    {
     "name": "Prohibited Strategy Flags",
     "note": "Set up automated behavioral alerts for latency arbitrage, toxic hedging, and high-frequency abuse.",
     "page": null
    },
    {
     "name": "KYC/AML Review Console",
     "note": "Track, approve, reject, or request updates for trader identity documentation.",
     "page": "kyc"
    },
    {
     "name": "Max Lot Size & Leverage Controller",
     "note": "Restrict maximum position sizing or leverage allowances per challenge asset class.",
     "page": null
    },
    {
     "name": "News Trading Restrictions Dashboard",
     "note": "Toggle and configure automated trading bans around high-impact economic news events.",
     "page": null
    },
    {
     "name": "Weekend Holding Settings",
     "note": "Enforce or bypass automatic position liquidations before market close on weekends.",
     "page": null
    },
    {
     "name": "Payout Request Approval Queue",
     "note": "Review, approve, or reject trader profit split withdrawal requests.",
     "page": "payouts"
    },
    {
     "name": "Profit-Split Percentage Slider",
     "note": "Customize or change the profit share split tier for individual traders.",
     "page": null
    },
    {
     "name": "Invoicing & Agreement Generator",
     "note": "Create, track, and archive legal payout agreements and contractor invoices.",
     "page": null
    },
    {
     "name": "Payment Gateway Management",
     "note": "Toggle, connect, and monitor crypto, card, or wire transfer payment processors.",
     "page": "orders"
    },
    {
     "name": "Refund Trigger Engine",
     "note": "Automate and track challenge fee refunds upon reaching specific funding milestones.",
     "page": null
    },
    {
     "name": "Affiliate & IB Commission Tracker",
     "note": "Manage referral payouts, tracking links, and custom payout structures.",
     "page": "partners"
    },
    {
     "name": "Chargeback & Dispute Handler",
     "note": "Flag, block, and manage accounts tied to fraudulent transaction disputes.",
     "page": null
    },
    {
     "name": "Pass / Fail Ratio Analytics",
     "note": "Track historical percentage trends of traders passing or failing evaluation phases.",
     "page": null
    },
    {
     "name": "Net Revenue & Liability Dashboard",
     "note": "Monitor challenge sales volume versus total pending and historical payout liabilities.",
     "page": null
    },
    {
     "name": "Aggregated Risk Exposure Matrix",
     "note": "View total net long/short exposure by asset class to assess firm risk.",
     "page": null
    },
    {
     "name": "Daily Active Traders (DAT) Tracker",
     "note": "Monitor platform engagement, volume, and active account numbers.",
     "page": null
    },
    {
     "name": "Customer Lifetime Value (LTV) Report",
     "note": "Calculate the average revenue generated per trader over their lifecycle.",
     "page": null
    },
    {
     "name": "Discount Code & Promo Campaign Builder",
     "note": "Generate percentage-based, fixed-amount, or time-limited challenge coupons.",
     "page": "offers"
    },
    {
     "name": "Challenge Ruleset Package Creator",
     "note": "Build and deploy new evaluation products with custom target parameters.",
     "page": "plans"
    },
    {
     "name": "Built-in Support Ticket System",
     "note": "Manage internal customer service inquiries, live chats, and support queues.",
     "page": "support"
    },
    {
     "name": "Automated Email Template Editor",
     "note": "Customize trigger-based emails for account creation, phase passing, and breaches.",
     "page": null
    },
    {
     "name": "Live Chat & Intercom Integration Panel",
     "note": "Connect and manage direct communications with online web traffic.",
     "page": "support"
    },
    {
     "name": "Broker & Trading Server Bridge",
     "note": "Manage APIs and connections to CK Trader servers.",
     "page": null
    },
    {
     "name": "Role-Based Access Control (RBAC)",
     "note": "Set granular permissions for support agents, risk managers, and financial admins.",
     "page": null
    },
    {
     "name": "Audit Trail & System Logs",
     "note": "Record every action taken by admins, including parameter changes and manually passed phases.",
     "page": "audit"
    },
    {
     "name": "White-Label Branding Settings",
     "note": "Update logos, theme colors, and domain mappings for the trader dashboard.",
     "page": "branding"
    },
    {
     "name": "Maintenance Mode Toggle",
     "note": "Take the user-facing portal offline for scheduled upgrades or technical maintenance.",
     "page": "markets"
    },
    {
     "name": "Multi-Currency & Localization Toggles",
     "note": "Configure supported fiat/crypto display currencies and system interface languages.",
     "page": null
    },
    {
     "name": "API Key Manager",
     "note": "Generate and revoke security credentials for external analytics or software integrations.",
     "page": null
    },
    {
     "name": "Consistency Rule Checker",
     "note": "Monitor and enforce trading consistency metrics (e.g., lot size deviation, trading volume uniformity).",
     "page": null
    },
    {
     "name": "Reset Fee Billing Module",
     "note": "Create and price \"challenge resets\" or \"extensions\" available for traders to purchase.",
     "page": null
    },
    {
     "name": "Slippage & Spread Simulation Panel",
     "note": "Manually adjust virtual spread markups or slippage parameters for evaluation environments.",
     "page": null
    },
    {
     "name": "Inactive Account Sweeper",
     "note": "Configure automatic archiving rules for accounts dormant for a set number of days.",
     "page": null
    },
    {
     "name": "Leaderboard & Badging Manager",
     "note": "Control which traders appear on public rankings and assign achievement badges.",
     "page": null
    },
    {
     "name": "Bulk Email/Notification Broadcaster",
     "note": "Send push notifications or emails to targeted segments of traders (e.g., all Phase 2 traders).",
     "page": null
    },
    {
     "name": "Two-Factor Authentication (2FA) Enforcer",
     "note": "Mandate and manage security verification setups for all admin and staff logins.",
     "page": "firm-security"
    },
    {
     "name": "Database Backup & Export Tool",
     "note": "Download system records, financial sheets, and trader data securely in standard file formats.",
     "page": null
    },
    {
     "name": "Liquidity Provider (LP) Analytics",
     "note": "Track execution speeds, rejection rates, and slippage data from external brokers or LPs.",
     "page": null
    }
   ]
  }
 ],
 "futures": [
  {
   "name": "Rader Profile & Account Lifecycle Controls",
   "features": [
    {
     "name": "360° Trader Master View",
     "note": "Centralized console displaying a trader’s identity, past history, active balances, and overall risk standing.",
     "page": "traders"
    },
    {
     "name": "Manual Phase Progression Override",
     "note": "Push an account manually from Phase 1 to Phase 2, Funded status, or a custom scaling bracket.",
     "page": "accounts"
    },
    {
     "name": "Balance & Equity Correction Matrix",
     "note": "Add or deduct financial capital, credit lines, or account adjustments directly on a trading account.",
     "page": null
    },
    {
     "name": "Breach Clearance & Account Reset Tool",
     "note": "Erase a rule violation flag instantly to reinstate or unlock a trader's account.",
     "page": "accounts"
    },
    {
     "name": "Platform Security Token Regenerator",
     "note": "Generate and resend trading platform login credentials, investor passwords, and API keys.",
     "page": null
    },
    {
     "name": "Bulk Account Assignor & Rule Tagging",
     "note": "Map custom rulesets, risk boundaries, or pricing tiers to hundreds of user accounts at once.",
     "page": null
    },
    {
     "name": "Multi-Accounting & IP Collision Tracker",
     "note": "Cross-reference device fingerprints and IP patterns to find account sharing or proxy management.",
     "page": "duplicates"
    },
    {
     "name": "Internal Operational Memo Logging",
     "note": "Attach confidential staff annotations, alerts, and operational tracking tags directly to a trader's profile.",
     "page": null
    },
    {
     "name": "Inactive Account Sweeper & Archiver",
     "note": "Run automated scripts to archive dormant evaluation or demo accounts after predefined inactivity periods.",
     "page": null
    }
   ]
  },
  {
   "name": "Risk Management & Rule Configuration Engine",
   "features": [
    {
     "name": "Real-Time Live Trade Stream",
     "note": "View every open position, floating PnL, margin utilization, and stop-loss level across the system.",
     "page": null
    },
    {
     "name": "Drawdown Boundary Configurator",
     "note": "Customize absolute or trailing maximum drawdowns and daily loss limits per challenge tier.",
     "page": null
    },
    {
     "name": "Emergency Global Firm-Wide Kill-Switch",
     "note": "Instantly close all open positions or completely freeze trading operations in a black-swan market event.",
     "page": null
    },
    {
     "name": "A-Book / B-Book Execution Bridge",
     "note": "Shift specific accounts or high-performing funded traders between internal simulation (B-Book) and live STP routing (A-Book).",
     "page": null
    },
    {
     "name": "Automated Strategy Abuse Monitor",
     "note": "Trigger automated behavior flags for high-frequency trading, latency arbitrage, or group collusion.",
     "page": null
    },
    {
     "name": "KYC/AML Review Desk",
     "note": "Track, inspect, approve, or reject identity verification records and corporate documentation.",
     "page": "kyc"
    },
    {
     "name": "Leverage & Volume Sizing Matrix",
     "note": "Control and cap maximum lot sizes, position counts, and leverage distributions based on the asset class.",
     "page": null
    },
    {
     "name": "News Trading Restriction Scheduler",
     "note": "Define specific high-impact economic news windows to auto-ban or auto-close positions for targeted challenges.",
     "page": null
    },
    {
     "name": "Weekend Holding Liquidation Engine",
     "note": "Enforce or whitelist specific account groups regarding mandatory Friday night position liquidation rules.",
     "page": null
    },
    {
     "name": "Consistency Metrics Validator",
     "note": "Define parameters for lot-size deviations or volume distributions to catch rule gaming.",
     "page": null
    }
   ]
  },
  {
   "name": "Financials, Payouts & Partnerships",
   "features": [
    {
     "name": "Payout Approval Desk & Queue",
     "note": "Review, cross-check against rules, and approve or reject client profit-split withdrawal requests.",
     "page": "payouts"
    },
    {
     "name": "Dynamic Profit-Split Slider",
     "note": "Adjust the percentage split ratio (e.g., changing from 80/20 to 90/10) dynamically for individual contract tiers.",
     "page": null
    },
    {
     "name": "Digital Contract & Invoice Archive",
     "note": "Generate, sign, and store digital contractor agreements and matching withdrawal invoice documents.",
     "page": null
    },
    {
     "name": "Payment Processor Matrix Manager",
     "note": "Integrate, prioritize, and toggle payment gateways for cards, bank wires, and crypto.",
     "page": null
    },
    {
     "name": "Refund Distribution Handler",
     "note": "Automate challenge fee refunds to funded traders upon reaching their first payout milestone.",
     "page": null
    },
    {
     "name": "Multi-Tier Affiliate & IB Network Tree",
     "note": "Set up and manage complex tracking networks with custom payout metrics for referral partners.",
     "page": "partners"
    },
    {
     "name": "Dispute & Chargeback Fraud Flagging",
     "note": "Lock, tag, and quarantine trading profiles experiencing active transaction chargeback disputes.",
     "page": null
    }
   ]
  },
  {
   "name": "Commercial Tools & Marketing Automation",
   "features": [
    {
     "name": "Challenge Ruleset Package Factory",
     "note": "Build and publish brand-new evaluation products with distinct targets and price points.",
     "page": null
    },
    {
     "name": "Coupon & Discount Engine",
     "note": "Create customized percentage-based, fixed-amount, or time-restricted promotional codes.",
     "page": "offers"
    },
    {
     "name": "Add-On Upgrades Price Desk",
     "note": "Configure pricing configurations for add-on options like \"No Stop Loss\" or \"Weekend Holding.\"",
     "page": null
    },
    {
     "name": "Challenge Reset & Extension Billing",
     "note": "Price and manage self-serve challenge resets or phase time extensions.",
     "page": null
    },
    {
     "name": "Gamification Reward Store Manager",
     "note": "Set up performance badges, achievements, and merchandise redemption triggers.",
     "page": null
    },
    {
     "name": "Public Leaderboard Moderation Desk",
     "note": "Control, filter, and moderate which traders appear on the public performance leaderboards.",
     "page": null
    },
    {
     "name": "Segmented Broadcast Messenger",
     "note": "Push batch emails, dashboard alerts, or text alerts to target user subsets (e.g., all active Phase 2 traders).",
     "page": null
    },
    {
     "name": "Automated System Trigger Email Templates",
     "note": "Design and automate emails for events like account creation, passed phases, and rule breaches.",
     "page": null
    }
   ]
  },
  {
   "name": "Platform Architecture & Security Settings",
   "features": [
    {
     "name": "Trading Server Bridge API Connectors",
     "note": "Sync and manage CK Trader server integrations.",
     "page": null
    },
    {
     "name": "Role-Based Access Control (RBAC)",
     "note": "Set specific permissions for backend roles like Support Desk, Risk Managers, Compliance Officers, and Admins.",
     "page": null
    },
    {
     "name": "Immutable Admin Audit Trail Logs",
     "note": "Log a permanent, un-editable record of every single action, change, or manual override taken by any staff member.",
     "page": "audit"
    },
    {
     "name": "White-Label Design Customizer",
     "note": "Update system color schemes, portal logos, custom layouts, and custom system domain routings.",
     "page": null
    },
    {
     "name": "Portal Maintenance Mode Switch",
     "note": "Put customer dashboards into offline mode for upgrades without disrupting live broker data feeds.",
     "page": "markets"
    },
    {
     "name": "Multi-Currency System Configuration",
     "note": "Set up accepted regional display currencies and internal system interface languages.",
     "page": null
    },
    {
     "name": "Secure Database Snapshot Backups",
     "note": "Create manual or scheduled system database backups with one-click restoration targets.",
     "page": null
    },
    {
     "name": "Enforced Admin 2FA Controls",
     "note": "Mandate and manage multi-factor authentication requirements for all internal employee accounts.",
     "page": "firm-security"
    }
   ]
  },
  {
   "name": "Analytics, BI & Support Operations",
   "features": [
    {
     "name": "Pass / Fail Conversion Matrix",
     "note": "Track conversion ratios detailing how many accounts pass Phase 1, Phase 2, or end in structural failure.",
     "page": null
    },
    {
     "name": "Net Revenue vs. Liability Monitor",
     "note": "Match challenge purchase revenue up against pending, floating, and historical payout liabilities.",
     "page": null
    },
    {
     "name": "Macro Exposure Risk Map",
     "note": "Aggregates overall long/short positions across all traders to determine extreme exposure risks.",
     "page": null
    },
    {
     "name": "Customer Lifetime Value (LTV) Calculator",
     "note": "Analyze how much gross and net revenue a single trader brings across multiple challenge attempts.",
     "page": null
    },
    {
     "name": "Internal Ticketing Hub",
     "note": "Assign, update, and resolve support requests, disputes, and rule breach appeals.",
     "page": "support"
    },
    {
     "name": "Live Customer Chat Controller",
     "note": "Route active client dashboard live chats straight to free customer support agents.",
     "page": null
    },
    {
     "name": "Slippage & Virtual Spread Markup Panel",
     "note": "Simulate or apply spread modifications and virtual slippage onto evaluation environments.",
     "page": null
    }
   ]
  }
 ],
 "perps": [
  {
   "name": "Web3 & Crypto Wallet Infrastructure",
   "features": [
    {
     "name": "On-Chain Deposit Tracker",
     "note": "Monitor incoming trader payments for challenge fees sent via USDC, USDT, BTC, or ETH networks.",
     "page": null
    },
    {
     "name": "Smart Contract Payout Disbursing System",
     "note": "Execute high-volume multi-sig crypto payout distributions natively on-chain with one click.",
     "page": "payouts"
    },
    {
     "name": "Gas Fee Optimization Console",
     "note": "Track and configure optimal gas fees for blockchain payouts during high network traffic.",
     "page": null
    },
    {
     "name": "Connected Wallet Profiler",
     "note": "Link and log a trader’s verified self-custody wallet addresses (MetaMask, Phantom, Ledger) directly to their CRM profile.",
     "page": null
    },
    {
     "name": "Crypto Payment Gateway Switcher",
     "note": "Connect, shift, or prioritize alternative crypto payment rails (e.g., Coinbase Commerce, Helio, BVNK).",
     "page": "orders"
    }
   ]
  },
  {
   "name": "Perps Risk Engine & Platform Rules Configurator",
   "features": [
    {
     "name": "Intraday vs. End-of-Day Drawdown Toggle",
     "note": "Instantly switch account groups between strict intraday high-water-mark tracking and safer End-of-Day (EOD) metrics.",
     "page": null
    },
    {
     "name": "Funding Rate Impact Evaluator",
     "note": "Monitor and adjust how platform funding rate deductions/credits affect a trader's floating daily drawdown calculations.",
     "page": null
    },
    {
     "name": "Leverage Bracket Allocator",
     "note": "Adjust precise sliding leverage scales (e.g., up to 50x or 100x) based on the specific crypto or tokenized asset class.",
     "page": null
    },
    {
     "name": "Maximum Contract/Notional Limit Controller",
     "note": "Define hard restrictions on the total dollar volume or size a trader can hold open simultaneously.",
     "page": null
    },
    {
     "name": "Hourly Swap/Holding Fee Manager",
     "note": "Configure custom holding or inventory fees charged to traders holding perps positions over extended hours.",
     "page": null
    },
    {
     "name": "Server Order/Request Cap Engine",
     "note": "Track and limit fast API scripts by capping a trader's allowed orders (e.g., maximum 100 concurrent orders, 2,000 daily changes).",
     "page": null
    },
    {
     "name": "Consistency Best-Day Cap Dashboard",
     "note": "Enforce and check automated rules verifying no single day accounts for more than 40%–50% of the total cleared challenge profit.",
     "page": null
    }
   ]
  },
  {
   "name": "Dealing Desk & Liquidity Feeds",
   "features": [
    {
     "name": "DEX Data Bridge & Oracle Health Check",
     "note": "Monitor live Web3 data feeds and prices pulled from external perp DEXs or central venues.",
     "page": null
    },
    {
     "name": "Bad Tick & Flash Crash Sanitizer",
     "note": "Automatically freeze or discard outlier price spikes from external feeds to prevent false account liquidations.",
     "page": null
    },
    {
     "name": "Virtual Spread Markup Controller",
     "note": "Manually adjust internal virtual bid/ask spreads during extreme crypto volatility.",
     "page": null
    },
    {
     "name": "A-Book Copy-Trading Pool Route",
     "note": "Route successful funded perp traders to an external API script that duplicates their setups onto real exchange accounts.",
     "page": null
    },
    {
     "name": "Aggregate Exposure Asset Matrix",
     "note": "View real-time net long/short positions across all traders to determine macro risk on highly volatile meme coins or low-liquidity pairs.",
     "page": null
    }
   ]
  },
  {
   "name": "Trader Management & Lifecycle Action",
   "features": [
    {
     "name": "360° Crypto Trader Dashboard",
     "note": "View a single console outlining a client’s cross-chain addresses, challenge histories, active metrics, and compliance statuses.",
     "page": "traders"
    },
    {
     "name": "Manual Step Progression Trigger",
     "note": "Push a trader instantly to a funded performance level or clear a rule target manually.",
     "page": null
    },
    {
     "name": "Rule Breach Clearance Tool",
     "note": "Reset account breach flags and allow the account to open new positions after a user pays a reset fee.",
     "page": null
    },
    {
     "name": "Emergency Individual Account Freeze",
     "note": "Pause all open position orders or temporarily revoke a user's API keys during suspicious activity investigations.",
     "page": null
    },
    {
     "name": "Balance & Credit Adjustment Console",
     "note": "Insert or remove manual capital allocations or balance adjustments directly onto active accounts.",
     "page": "accounts"
    },
    {
     "name": "Multi-Accounting & IP Collision Tracker",
     "note": "Cross-reference device configurations, localized login times, and IP trees to flag group collusion or illegal third-party account management.",
     "page": "duplicates"
    }
   ]
  },
  {
   "name": "Challenge Shop & Product Pricing",
   "features": [
    {
     "name": "1-Step Evaluation Package Creator",
     "note": "Deploy new multi-asset or crypto-only 1-step challenge models with distinct profit targets.",
     "page": "plans"
    },
    {
     "name": "Coupon & Promotion Code Factory",
     "note": "Build custom marketing discount tools, flash sales, and influencer coupon metrics.",
     "page": "offers"
    },
    {
     "name": "Add-On Upgrade Checkbox Pricing",
     "note": "Price add-on features like \"News Trading Allowed\" or \"Increased Leverage Options.\"",
     "page": null
    },
    {
     "name": "Challenge Reset Store Manager",
     "note": "Set up and price self-serve automated reset options for failed accounts.",
     "page": null
    },
    {
     "name": "Display Currency and Interface Localization",
     "note": "Adjust regional display views (fiat or stablecoins) and target languages for global users.",
     "page": null
    }
   ]
  },
  {
   "name": "Financials, Compliance & Security",
   "features": [
    {
     "name": "Payout Request Approval Desk",
     "note": "Audit pending trader withdrawals against consistency scores and compliance targets before clearing funds.",
     "page": "payouts"
    },
    {
     "name": "Profit-Split Percentage Slider",
     "note": "Adjust the split metrics (e.g., from 80/20 up to 90/10 scaling tracks) individually by user tier.",
     "page": null
    },
    {
     "name": "KYC/AML Document Review Matrix",
     "note": "Verify user documentation or manage integrations with external verification engines.",
     "page": "kyc"
    },
    {
     "name": "Quarantine Ledger for Disputed Tx",
     "note": "Automatically freeze profiles linked to chargebacks, fraudulent transaction issues, or exploits.",
     "page": null
    },
    {
     "name": "Role-Based Access Control (RBAC)",
     "note": "Restrict system views so sales staff see customer data, while dealing desks see trades, and only top admins see wallet keys.",
     "page": null
    },
    {
     "name": "System Audit Trail Logs",
     "note": "Maintain a permanent log of all adjustments, balance tweaks, or rule overrides made by any staff member.",
     "page": "audit"
    },
    {
     "name": "Admin 2FA Verification Policy",
     "note": "Force multi-factor app validation or hardware keys on all corporate team portal access points.",
     "page": "firm-security"
    },
    {
     "name": "Portal Maintenance Mode Switch",
     "note": "Disconnect customer dashboards for updates while keeping active exchange data feeds online.",
     "page": "markets"
    }
   ]
  },
  {
   "name": "Analytics & Growth Tools",
   "features": [
    {
     "name": "Pass / Fail Conversion Matrix",
     "note": "Measure statistical performance showing how many evaluation accounts hit targets vs. hitting drawdowns.",
     "page": null
    },
    {
     "name": "Net Revenue vs. Pending Liability Sheet",
     "note": "Compare total challenge purchase volume up against current floating payout exposures.",
     "page": null
    },
    {
     "name": "Customer Lifetime Value (LTV) Calculator",
     "note": "Analyze historical performance data to see the average spend and volume generated per trader.",
     "page": null
    },
    {
     "name": "Asset Popularity Tracker",
     "note": "Monitor high-frequency heatmaps showing which tokens or indices are capturing the most volume at any minute.",
     "page": null
    },
    {
     "name": "Affiliate Tree & IB Commission Manager",
     "note": "Track multi-level referral tracking paths, custom links, conversions, and partner payout balances.",
     "page": "partners"
    }
   ]
  },
  {
   "name": "Support & Gamification Features",
   "features": [
    {
     "name": "Internal Ticket Hub",
     "note": "Assign, monitor, and resolve trader appeals regarding liquidations or technical platform lags.",
     "page": "support"
    },
    {
     "name": "Live Chat Controller",
     "note": "Sync directly into user web dashboards to route live chats straight to customer care agents.",
     "page": "support"
    },
    {
     "name": "Achievement Badge & Merch Engine",
     "note": "Configure reward triggers that grant achievement milestones based on rare performance metrics.",
     "page": null
    },
    {
     "name": "Public Leaderboard Moderation",
     "note": "Vet, control, or hidden-list specific profiles from public community performance boards.",
     "page": null
    },
    {
     "name": "Automated PDF Certificate Generator",
     "note": "Push instantly downloadable Phase Pass or Funded Status certificates to successful traders.",
     "page": "certificates"
    },
    {
     "name": "Economic Calendar Alert System",
     "note": "Push targeted dashboard announcements to traders warning them of high-impact releases or token migrations.",
     "page": null
    },
    {
     "name": "Segmented Notification Broadcaster",
     "note": "Send batch dashboard notifications or emails to distinct cohorts (e.g., all active funded crypto traders).",
     "page": null
    },
    {
     "name": "Database Snapshot & Backup Core",
     "note": "Generate secure server database sheets with one-click restoration targets",
     "page": null
    }
   ]
  }
 ],
 "predict": [
  {
   "name": "Market Creation & Lifecycle Management",
   "features": [
    {
     "name": "Market Creator Wizard",
     "note": "A step-by-step console to deploy new prediction markets with custom titles, descriptions, categories, and tags.",
     "page": null
    },
    {
     "name": "Resolution Source Configurator",
     "note": "Define exact criteria and primary URLs used to resolve a market (e.g., official government websites, major news outlets).",
     "page": null
    },
    {
     "name": "Expiration & Halting Scheduler",
     "note": "Program specific dates and exact millisecond times for when a market automatically stops accepting new trades.",
     "page": null
    },
    {
     "name": "Outcome Parameter Editor",
     "note": "Configure markets by type—Binary (Yes/No), Categorical (Multiple Choice), or Scalar (Range-based numbers).",
     "page": null
    },
    {
     "name": "Conditional Market Mapper",
     "note": "Link related markets together so the outcome of one automatically adjusts or unlocks another (e.g., \"Will Candidate X win?\" linking to \"Will the GDP grow if Candidate X wins?\").",
     "page": null
    },
    {
     "name": "Market Status Lifecycle Toggles",
     "note": "Manually switch markets between Draft, Active, Paused, Halting, Resolved, or Voided/Canceled.",
     "page": "markets"
    },
    {
     "name": "Market Validation Queue",
     "note": "A moderation desk where staff review, edit, and approve markets proposed by users or community members.",
     "page": null
    },
    {
     "name": "Image & Creative Asset Uploader",
     "note": "Manage logos, icons, and promotional banners tied to specific markets or trending categories.",
     "page": null
    }
   ]
  },
  {
   "name": "Market Resolution & Oracle Management",
   "features": [
    {
     "name": "Manual Resolution Overlay",
     "note": "Override or input final event outcomes manually to distribute payouts to winning shareholders.",
     "page": null
    },
    {
     "name": "Oracle API Integration Hub",
     "note": "Connect and monitor decentralized automated data feeds (e.g., Chainlink) or centralized data APIs (e.g., sports feeds).",
     "page": null
    },
    {
     "name": "Oracle Dispute Mediation Desk",
     "note": "Pause markets and review evidence when users file a dispute against an oracle's automated resolution.",
     "page": null
    },
    {
     "name": "Resolution Delay Scheduler",
     "note": "Implement a mandatory cooling-off window post-event before funds are distributed to allow for user appeals.",
     "page": null
    },
    {
     "name": "Void Market & Refund Trigger",
     "note": "Instantly cancel a market due to ambiguous real-world outcomes and return all initial capital to participants.",
     "page": null
    }
   ]
  },
  {
   "name": "Liquidity, Automated Market Makers (AMM) & Pricing",
   "features": [
    {
     "name": "AMM Parameter Configurator",
     "note": "Choose and fine-tune pricing algorithms (e.g., LMSR - Logarithmic Market Scoring Rule, or CPMM - Constant Product Market Maker).",
     "page": null
    },
    {
     "name": "Firm-Backed Liquidity Injector",
     "note": "Add seed capital or baseline liquidity tokens to newly launched markets to stabilize initial trading spreads.",
     "page": null
    },
    {
     "name": "Dynamic Trading Fee Matrix",
     "note": "Adjust platform transaction fees (e.g., 1% per trade or fee on winning payouts only) globally or per market.",
     "page": null
    },
    {
     "name": "Limit Order Book Engine Dashboard",
     "note": "Monitor and manage traditional peer-to-peer limit order queues for platforms not relying solely on AMMs.",
     "page": null
    },
    {
     "name": "Slippage & Price Impact Caps",
     "note": "Enforce maximum trade slippage thresholds to protect users from severe price manipulation in low-liquidity markets.",
     "page": null
    }
   ]
  },
  {
   "name": "Risk Controls & Market Surveillance",
   "features": [
    {
     "name": "Real-Time Volume & Open Interest Stream",
     "note": "View live order feeds, current share distributions, and total value locked (TVL) per market.",
     "page": null
    },
    {
     "name": "Insider Trading & Manipulation Tracker",
     "note": "Receive automated alerts for massive, sudden volume spikes originating from single accounts or shared IPs.",
     "page": null
    },
    {
     "name": "Emergency Global Freeze Kill-Switch",
     "note": "Instantly halt all trading, order matching, and resolutions across the entire platform in a technical emergency.",
     "page": null
    },
    {
     "name": "Maximum Trade/Position Sizing Cap",
     "note": "Restrict the maximum amount of shares or total capital a single account can risk on a single outcome.",
     "page": null
    },
    {
     "name": "Collusion & Sybil Attack Detector",
     "note": "Track and flag multiple seemingly unrelated accounts buying identical obscure outcomes from similar device configurations.",
     "page": null
    }
   ]
  },
  {
   "name": "User Area, Wallets & Financials",
   "features": [
    {
     "name": "360° User Portfolio View",
     "note": "View a master console outlining a user’s historical predictions, open shares, active wallet balances, and win/loss ratios.",
     "page": "traders"
    },
    {
     "name": "Multi-Chain Deposit and Payment Gateway Tracker",
     "note": "Monitor incoming user funding via crypto stablecoins (USDC/USDT) or fiat rails.",
     "page": "orders"
    },
    {
     "name": "Withdrawal Request Desk & Manual Queue",
     "note": "Audit, approve, or reject high-volume user profit withdrawals.",
     "page": null
    },
    {
     "name": "Manual Balance Adjustments Console",
     "note": "Issue manual credits, debits, or loyalty bonus tokens directly to a user's internal wallet.",
     "page": "accounts"
    },
    {
     "name": "Chargeback & Fraud Quarantine Ledger",
     "note": "Automatically freeze profiles linked to payment disputes or identity theft flags.",
     "page": null
    }
   ]
  },
  {
   "name": "Marketing, Gamification & Partnerships",
   "features": [
    {
     "name": "Trending & Featured Market Manager",
     "note": "Pinot highlight specific high-volume or viral markets to the main client portal homepage.",
     "page": null
    },
    {
     "name": "Promo Code & Free Bet Voucher Factory",
     "note": "Generate targeted marketing campaigns offering risk-free promotional prediction credits.",
     "page": "offers"
    },
    {
     "name": "Leaderboard & Whales Moderation Desk",
     "note": "Review and control public rankings of the platform's top-performing or highest-volume predictors.",
     "page": null
    },
    {
     "name": "Affiliate & IB Commission Tracker",
     "note": "Manage referral tracking paths, custom links, sign-ups, and partner payout balances.",
     "page": "partners"
    },
    {
     "name": "Push Notification & Notification Broadcaster",
     "note": "Send bulk dashboard alerts or emails regarding market resolutions, trending topics, or new listings.",
     "page": null
    },
    {
     "name": "Automated Social Media Poster API",
     "note": "Toggle automated scripts that tweet or post newly listed markets and major payouts to community channels.",
     "page": null
    }
   ]
  },
  {
   "name": "Security, Architecture & System Configuration",
   "features": [
    {
     "name": "Role-Based Access Control (RBAC)",
     "note": "Restrict system access levels (e.g., Support can view tickets; Market Creators can only build markets; only Admins resolve payouts).",
     "page": null
    },
    {
     "name": "Immutable System Audit Trail Logs",
     "note": "Log an unalterable history of every single market resolution, manual balance tweak, or configuration adjustment made by an admin.",
     "page": "audit"
    },
    {
     "name": "Admin 2FA Security Enforcement",
     "note": "Mandate hardware keys or authenticator apps for all employee portal logins.",
     "page": "firm-security"
    },
    {
     "name": "White-Label Portal Customizer",
     "note": "Edit frontend platform logos, color themes, domain configurations, and localized metadata.",
     "page": null
    },
    {
     "name": "Maintenance Mode Switch",
     "note": "Take user portals offline for technical updates while leaving back-end data bridges and processing scripts running.",
     "page": "markets"
    },
    {
     "name": "Secure Database Backup & Recovery Core",
     "note": "Export full system tables or trigger restoration points securely.",
     "page": null
    }
   ]
  },
  {
   "name": "Analytics, Business Intelligence & Support",
   "features": [
    {
     "name": "Platform Gross Revenue & Take-Rate Sheet",
     "note": "View aggregate data mapping platform earnings from transaction fees, profit cuts, or liquidity provisioning.",
     "page": null
    },
    {
     "name": "User Win / Loss Distribution Analytics",
     "note": "Evaluate the percentage of profitable users vs. losing users to balance platform ecosystem health.",
     "page": null
    },
    {
     "name": "Category Popularity Heatmap",
     "note": "Visualize which topics (e.g., Politics, Pop Culture, Tech, Macroeconomics) generate the most volume.",
     "page": null
    },
    {
     "name": "Built-in Customer Support Ticket Engine",
     "note": "Resolve user inquiries regarding market definitions, stuck transactions, or platform bugs.",
     "page": "support"
    },
    {
     "name": "Live Chat Interceptor Control",
     "note": "Route active client dashboard live chats to available customer service representatives.",
     "page": "support"
    },
    {
     "name": "Regulatory Compliance Exporter",
     "note": "Generate financial or transaction history sheets formatted for local compliance audits.",
     "page": null
    },
    {
     "name": "API Key Infrastructure Manager",
     "note": "Issue or revoke data tokens allowing third-party trackers (like CoinGecko or custom bots) to aggregate market data.",
     "page": null
    }
   ]
  }
 ],
 "fx": [
  {
   "name": "General",
   "features": [
    {
     "name": "Client 360-Degree Profile",
     "note": "View a master dashboard of a client's personal details, trading accounts, financial history, and compliance status.",
     "page": "traders"
    },
    {
     "name": "Lead Assignment Engine",
     "note": "Route incoming leads automatically to specific sales agents or retention teams based on region, language, or campaign.",
     "page": null
    },
    {
     "name": "Document Verification (KYC) Console",
     "note": "Review, approve, or reject identity and residential documents natively.",
     "page": "kyc"
    },
    {
     "name": "AML Screen & Sanction List Matcher",
     "note": "Scan client names automatically against global anti-money laundering and political watchlists.",
     "page": null
    },
    {
     "name": "Client Status Lifecycle Controls",
     "note": "Change user accounts manually between statuses like Active, Frozen, Inactive, Blocked, or Terminated.",
     "page": null
    },
    {
     "name": "Internal Commenting & Tagging",
     "note": "Add private staff notes, operational warnings, and high-value tags to client profiles.",
     "page": null
    },
    {
     "name": "Interaction History Timeline",
     "note": "Track every phone call log, email, ticket, and portal login timestamp for a client.",
     "page": null
    },
    {
     "name": "IP Address Geolocation Cross-Check",
     "note": "Monitor login locations to detect unauthorized account access or proxy trading.",
     "page": null
    },
    {
     "name": "Duplicate Account Detector",
     "note": "Scan the database automatically for matching details (IP, phone, hardware ID) to catch multi-accounting abuse.",
     "page": "duplicates"
    },
    {
     "name": "VIP & Corporate Account Manager",
     "note": "Configure distinct profile rules for corporate entities, trusts, and high-net-worth individuals.",
     "page": null
    },
    {
     "name": "Account Dormancy Sweeper",
     "note": "Archive inactive trading accounts automatically after a configurable period of non-use.",
     "page": null
    },
    {
     "name": "Bulk Client Importer/Exporter",
     "note": "Move large volumes of client data securely via encrypted standard file formats.",
     "page": null
    }
   ]
  },
  {
   "name": "Trading Account Configuration",
   "features": [
    {
     "name": "Account Group Allocator",
     "note": "Assign trading accounts to specific server groups (e.g., Fixed Spread, ECN, Raw, Swap-Free).",
     "page": null
    },
    {
     "name": "Leverage Configurator",
     "note": "Set and modify maximum leverage limits (e.g., 1:30 to 1:500) at the individual account or group level.",
     "page": null
    },
    {
     "name": "Dynamic Margin Call & Stop Out Tweaker",
     "note": "Set precise percentage levels that trigger warnings or forced liquidations.",
     "page": null
    },
    {
     "name": "Swap-Free / Islamic Account Switcher",
     "note": "Toggle the collection or payment of interest overnight for specific accounts.",
     "page": null
    },
    {
     "name": "Custom Commission Schedules",
     "note": "Assign distinct per-lot or per-trade commission charges to specific accounts or client tiers.",
     "page": null
    },
    {
     "name": "Markup Profile Builder",
     "note": "Create and apply structural pip markups to spreads for specific marketing campaigns or asset classes.",
     "page": null
    },
    {
     "name": "Platform Credentials Reset Engine",
     "note": "Regenerate and send platform login passwords, investor passwords, and secure tokens.",
     "page": "accounts"
    },
    {
     "name": "Currency Denomination Manager",
     "note": "Set up and manage trading accounts denominated in various base currencies (USD, EUR, GBP, BTC, etc.).",
     "page": null
    }
   ]
  },
  {
   "name": "Financial & Treasury Management",
   "features": [
    {
     "name": "Deposit Processing Control Panel",
     "note": "Approve, track, and log incoming manual wire transfers, card transactions, and alternative payments.",
     "page": null
    },
    {
     "name": "Withdrawal Request Approval Queue",
     "note": "Validate, authorize, or reject client profit and principal cash-out requests.",
     "page": null
    },
    {
     "name": "Manual Balance Adjustments",
     "note": "Deposit or withdraw cash directly from a client's balance for corrections, rewards, or compensations.",
     "page": "accounts"
    },
    {
     "name": "Credit & Bonus Issuer",
     "note": "Inject or remove non-withdrawable trading credits/bonuses into live accounts.",
     "page": null
    },
    {
     "name": "Internal Balance Transfer Manager",
     "note": "Approve or restrict the movement of funds between a client's separate trading accounts or wallets.",
     "page": null
    },
    {
     "name": "Payment Gateway Routing Manager",
     "note": "Toggle, prioritize, and route transactions through various integrated PSPs (Payment Service Providers).",
     "page": "orders"
    },
    {
     "name": "Chargeback Dispute Log",
     "note": "Flag, track, and lock accounts undergoing credit card fraud or transaction disputes.",
     "page": null
    },
    {
     "name": "Multi-Currency Internal Wallet System",
     "note": "Manage unified customer funding wallets separate from active CK Trader accounts.",
     "page": null
    },
    {
     "name": "Daily Cash Flow Ledger",
     "note": "View real-time aggregate inflows, outflows, and net funding metrics across the firm.",
     "page": null
    },
    {
     "name": "Automated Invoice Generator",
     "note": "Create corporate invoices and billing confirmations for institutional clients or partners.",
     "page": null
    }
   ]
  },
  {
   "name": "Risk Management & Dealing Desk Controls",
   "features": [
    {
     "name": "Live Order Stream View",
     "note": "Monitor every active market, limit, stop, and pending order executed across the server in real time.",
     "page": null
    },
    {
     "name": "A-Book / B-Book Execution Switcher",
     "note": "Toggle whether an account's trades are passed to external liquidity (A-Book) or internalized (B-Book).",
     "page": null
    },
    {
     "name": "Aggregate Exposure Matrix",
     "note": "View net long/short positions, total volume, and overall financial exposure per financial asset class.",
     "page": null
    },
    {
     "name": "Emergency Server Kill-Switch",
     "note": "Freeze all trading activities, order executions, and price feeds instantly in a crisis.",
     "page": null
    },
    {
     "name": "Symbol / Instrument Halting Panel",
     "note": "Suspend trading for specific individual currency pairs, indices, or crypto assets during market anomalies.",
     "page": null
    },
    {
     "name": "Slippage Enforcement Settings",
     "note": "Configure maximum allowable execution slippage ranges for market orders.",
     "page": null
    },
    {
     "name": "Virtual Spread Markups Manager",
     "note": "Adjust live bid/ask spreads dynamically during high volatility or off-market hours.",
     "page": null
    },
    {
     "name": "Scalper & Arbitrage Alert Monitor",
     "note": "Track and flag high-frequency accounts using toxic latency arbitrage or micro-scalping strategies.",
     "page": null
    },
    {
     "name": "Toxic Hedging Detection System",
     "note": "Identify accounts coordinating opposite trades across identical IPs or correlated assets to exploit systems.",
     "page": null
    },
    {
     "name": "Negative Balance Protection (NBP) Trigger",
     "note": "Automate the process of resetting negative account balances back to zero post-stop-out.",
     "page": null
    },
    {
     "name": "Client PnL Tracker",
     "note": "Monitor historical win/loss ratios to separate highly profitable traders from losing ones.",
     "page": null
    },
    {
     "name": "Dividends & Corporate Action Adjustments",
     "note": "Apply manual or automated cash adjustments for equity CFD dividend payouts or stock splits.",
     "page": null
    }
   ]
  },
  {
   "name": "Liquidity & Bridge Configurations",
   "features": [
    {
     "name": "Liquidity Provider (LP) Connection Bridge",
     "note": "Manage API integrations, price feeds, and order execution tunnels with Tier-1 banks or prime brokers.",
     "page": null
    },
    {
     "name": "LP Routing Rules Matrix",
     "note": "Configure smart order routing rules based on execution speed, pricing depth, or time of day.",
     "page": null
    },
    {
     "name": "Execution Latency Monitor",
     "note": "Track the exact time (in milliseconds) it takes for external LPs to fill A-book orders.",
     "page": null
    },
    {
     "name": "Rejection & Re-quote Tracker",
     "note": "Monitor how often external liquidity providers reject orders or issue re-quotes.",
     "page": null
    },
    {
     "name": "LP Balance & Margin Alerter",
     "note": "Receive notifications when collateral capital deposited with external prime brokers drops below safe operational limits.",
     "page": null
    },
    {
     "name": "Price Feed Sanitizer",
     "note": "Filter out \"bad ticks,\" sudden market spikes, and corrupted pricing data coming from external streams.",
     "page": null
    }
   ]
  },
  {
   "name": "Introducing Broker (IB) & Affiliate Management",
   "features": [
    {
     "name": "Multi-Tier IB Tree Builder",
     "note": "Design and track hierarchical affiliate structures (Master IBs, Sub-IBs, and agents).",
     "page": "partners"
    },
    {
     "name": "Rebate Configuration Engine",
     "note": "Set up exact payout formulas per traded lot (e.g., fixed pip value, percentage of spread, or percentage of commission).",
     "page": null
    },
    {
     "name": "Affiliate Link & Tracker Generator",
     "note": "Create unique referral links, coupon codes, and banner tracking parameters.",
     "page": "partners"
    },
    {
     "name": "Real-Time Commission Settlement Module",
     "note": "Automate the calculation and immediate distribution of IB payouts into partner wallets.",
     "page": null
    },
    {
     "name": "Partner Portal Access Controller",
     "note": "Manage what tools, client lists, and statistical reports IBs can see inside their custom sub-portals.",
     "page": "partners"
    },
    {
     "name": "Marketing Material Repository",
     "note": "Upload and distribute banners, landing pages, and compliance-approved creatives to the affiliate network.",
     "page": null
    }
   ]
  },
  {
   "name": "Marketing & Automation Tools",
   "features": [
    {
     "name": "Promo Code & Bonus Campaign Manager",
     "note": "Build time-limited deposit matching bonuses or volume-based reward schemes.",
     "page": "offers"
    },
    {
     "name": "Bulk Notification Broadcaster",
     "note": "Send push alerts, SMS notifications, or dashboard pop-ups to filtered groups of traders.",
     "page": null
    },
    {
     "name": "Drip Email Template System",
     "note": "Create and schedule automated email sequences for new registrations, inactive users, or birthday greetings.",
     "page": null
    },
    {
     "name": "Custom Trading Contests Module",
     "note": "Run demo or live trading competitions with active tracking leaderboards.",
     "page": null
    },
    {
     "name": "Banner and Popup Manager",
     "note": "Publish targeted system notices and marketing offers inside the client portal based on user behavior.",
     "page": null
    }
   ]
  },
  {
   "name": "System Security & Architecture",
   "features": [
    {
     "name": "Role-Based Access Control (RBAC)",
     "note": "Set granular permissions for staff (e.g., Sales can see leads but not balances; Dealing Desk can see trades but not KYC).",
     "page": null
    },
    {
     "name": "Complete System Audit Logs",
     "note": "Review a permanent record of every click, modification, password change, or balance adjustment made by any admin.",
     "page": "audit"
    },
    {
     "name": "Two-Factor Authentication (2FA) Enforcer",
     "note": "Mandate hardware or app-based 2FA tokens for all staff and admin logins.",
     "page": "firm-security"
    },
    {
     "name": "IP Whitelisting for Admin Portal",
     "note": "Restrict access to the backend admin dashboard to specific corporate office IP addresses or secure VPNs.",
     "page": "firm-security"
    },
    {
     "name": "Database Backup & Snapshot Schedule",
     "note": "Trigger manual or automated off-site database backups with one-click restore options.",
     "page": null
    },
    {
     "name": "API Key Infrastructure Manager",
     "note": "Issue, monitor, and revoke secure cryptographic tokens for third-party application plug-ins.",
     "page": null
    },
    {
     "name": "Maintenance Mode Switch",
     "note": "Put user-facing web portals or mobile apps into offline mode for upgrades while leaving backend server bridges active.",
     "page": "markets"
    },
    {
     "name": "Session Timeout Controller",
     "note": "Configure automated logouts for idle admin and manager dashboards to prevent unauthorized local access.",
     "page": "firm-security"
    }
   ]
  },
  {
   "name": "Compliance, Auditing & Reporting",
   "features": [
    {
     "name": "Regulatory Reporting Exporter",
     "note": "Generate standardized transaction files required by bodies like CySEC, FCA, ASIC, or FSA.",
     "page": null
    },
    {
     "name": "Suspicious Activity Alert Engine",
     "note": "Flag trades or transfers that cross specific size thresholds or look like structural money laundering.",
     "page": null
    },
    {
     "name": "Daily Financial Close Report",
     "note": "Generate automated daily end-of-day balances, including cash summaries, open equity, and floating liabilities.",
     "page": null
    },
    {
     "name": "Client Complaint Log",
     "note": "Centralize, track, and store official regulatory complaints and resolution history.",
     "page": null
    },
    {
     "name": "Tax Report Exporter",
     "note": "Pull annual gain/loss summaries (e.g., 1099 or local equivalents) for clients' tax filings.",
     "page": null
    }
   ]
  },
  {
   "name": "Analytics & Business Intelligence",
   "features": [
    {
     "name": "Sales Pipeline Tracker",
     "note": "Monitor conversion statistics from initial website registration to first-time deposit (FTD).",
     "page": null
    },
    {
     "name": "Retention Analytics Dashboard",
     "note": "Track active client churn rates, repeat deposit frequencies, and average customer account lifespans.",
     "page": null
    },
    {
     "name": "Customer Acquisition Cost (CAC) Monitor",
     "note": "Compare advertising spend against new client deposits to determine campaign ROI.",
     "page": null
    },
    {
     "name": "Volume Metrics Panel",
     "note": "View total lots traded per day, categorized by asset class, country, or account type.",
     "page": null
    },
    {
     "name": "Spread Revenue Calculator",
     "note": "Track the direct revenue generated purely from B-book spreads and system markups.",
     "page": null
    },
    {
     "name": "Asset Popularity Heatmap",
     "note": "Visualize which instruments (e.g., EURUSD, Gold, Bitcoin) are heavily traded at any given moment.",
     "page": null
    }
   ]
  },
  {
   "name": "Helpdesk & Client Support Integration",
   "features": [
    {
     "name": "Internal Ticketing Hub",
     "note": "Assign, prioritize, resolve, and close client technical or financial assistance requests.",
     "page": "support"
    },
    {
     "name": "Live Chat Interceptor",
     "note": "View active web chats and assign conversations directly to available support desk agents.",
     "page": "support"
    },
    {
     "name": "Knowledge Base Manager",
     "note": "Create and update help articles, FAQs, and tutorial documents visible in the trader portal.",
     "page": null
    },
    {
     "name": "Macro Reply Shortcodes",
     "note": "Build canned, pre-approved responses for customer service agents handling common queries.",
     "page": null
    },
    {
     "name": "Customer Satisfaction (CSAT) Tracker",
     "note": "Review ratings and feedback left by clients after their support tickets are closed.",
     "page": null
    }
   ]
  },
  {
   "name": "Platform & Asset Symbol Management",
   "features": [
    {
     "name": "Symbol Specification Editor",
     "note": "Modify contract sizes, minimum/maximum trade sizes, and step lots for any instrument.",
     "page": null
    },
    {
     "name": "Market Hours Scheduler",
     "note": "Set opening, closing, and break times for distinct global exchanges and markets.",
     "page": null
    },
    {
     "name": "Margin Tier Configuration Matrix",
     "note": "Set up dynamic margin rules that automatically decrease leverage as a trader's position size grows.",
     "page": null
    },
    {
     "name": "Holiday Schedule Overrides",
     "note": "Add custom calendar exclusions to automatically pause asset trading on national or global holidays.",
     "page": null
    },
    {
     "name": "Crypto Gas & Network Fee Tweaker",
     "note": "Adjust manual network fee settings for crypto-based deposits and withdrawals.",
     "page": null
    }
   ]
  },
  {
   "name": "Copy Trading & Social Module Controls",
   "features": [
    {
     "name": "Strategy Provider Leaderboard Controller",
     "note": "Approve or delist master traders from the public copy-trading rankings based on performance.",
     "page": null
    },
    {
     "name": "Performance Fee Manager",
     "note": "Configure how master traders collect profit shares from their investors (e.g., High-Water Mark settings).",
     "page": null
    },
    {
     "name": "Investor Allocation Engine",
     "note": "Monitor how capital is copied, allowing admins to manually disconnect followers from toxic strategies.",
     "page": null
    },
    {
     "name": "Copier Risk Limits Dashboard",
     "note": "Impose hard stop-loss limits on copy accounts to protect retail investors from master trader drawdowns.",
     "page": null
    },
    {
     "name": "Master Profile Verification Console",
     "note": "Vet and verify expert traders requesting public status with distinct visual checkmarks.",
     "page": null
    }
   ]
  }
 ]
};
